import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UploadDromoImportResults as UploadDromoImportResultsMutation,
    UploadDromoImportResultsVariables as UploadDromoImportResultsVariables,
    DromoImportInput,
} from 'nutshell-graphql-types';

import UPLOAD_DROMO_IMPORT_RESULTS from '../mutations/upload-dromo-import-results.graphql';

export const useUploadDromoImportResults = (): {
    uploadDromoImportResults: (arg1: DromoImportInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [uploadDromoImportResults, {loading, error}] = useMutation<
        UploadDromoImportResultsMutation,
        UploadDromoImportResultsVariables
    >(UPLOAD_DROMO_IMPORT_RESULTS);

    return {
        uploadDromoImportResults: (input: DromoImportInput) =>
            uploadDromoImportResults({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
